<template>
  <el-dialog
    v-el-drag-dialog
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    class="app-main-inner"
    :title="$t('queryJob.TrailerTrackingUsageNotice')"
    width="450px"
  >
    <div style="width: 345px;">
      <span style="display: block">{{ $t('queryJob.TrailerTrackingUsageNotice') }}</span>
      <span style="display: block">{{ $t('queryJob.N1SituationIncludingButDepartments') }}</span>
      <span style="display: block">{{ $t('queryJob.N2ConsentBeforeQueryingCommunication') }}</span>
      <span style="display: block">{{ $t('queryJob.N3TheOwnersConsentConsequences') }}</span>
      <span style="display: block">{{ $t('queryJob.N4ItToIrrelevantUser') }}</span>
      <span style="display: block">{{ $t('queryJob.N5SystemCannotGuaranteeResponsibility') }}</span>
      <span style="display: block">{{ $t('queryJob.N6BeAwareOfHome') }}</span>
      <el-checkbox v-model="notRemindNextTime">{{ $t('queryJob.DoNotRemindMeAgain') }}</el-checkbox>
      <center>
        <el-button @click="submitHandler">{{ $t('queryJob.IUnderstoodAndConfirmContinuing') }}</el-button>
      </center>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'YazuishouDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      notRemindNextTime: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    submitHandler() {
      this.$emit('submit', this.notRemindNextTime)
    }
  }
}
</script>

<style>
</style>
